'use client';

/**
 * Shared `enabled` predicate for TanStack Query hooks that hit
 * workspace-scoped BE endpoints (i.e. anything the
 * TenantContextGuard 400s on if x-workspace-id is missing).
 *
 * Gate on the user-selected workspace from `useWorkspaceStore`, treating
 * the cross-workspace ('all') view as disabled.
 *
 * Use this from any hook that previously did the inline gate against
 * `useWorkspaceStore.activeWorkspaceId !== 'all'`.
 */
import { useWorkspaceStore } from '@/stores';

export function useWorkspaceScopedEnabled(): boolean {
  const activeWorkspaceId = useWorkspaceStore((s) => s.activeWorkspaceId);

  // A concrete workspace must be selected.
  return !!activeWorkspaceId && activeWorkspaceId !== 'all';
}
